import i18n from '@if/core/i18n'
import { Stack, Typography } from '@mui/material'
import { FinancingProgramProvider } from '@src/data/types/FinancingProgramProvider'
import { MechanicalWarrantyProduct } from '@src/data/types/MechanicalWarrantyProduct'
import { useTranslation } from 'react-i18next'

interface Props {
  mechanicalWarrantyProvider: FinancingProgramProvider
  mechanicalProduct: MechanicalWarrantyProduct
}

const MechanicalWarrantySection = ({
  mechanicalWarrantyProvider,
  mechanicalProduct,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column">
      <Typography variant="h6" component="div" gutterBottom>
        {t('worksheetCommon.insuranceDetails')}
      </Typography>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('mechanicalWarrantyWorksheet.providerLabel')} :</Typography>
        <Typography variant="subtitle1">
          {i18n.language === 'fr'
            ? mechanicalWarrantyProvider.nameFr
            : mechanicalWarrantyProvider.nameEn}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('mechanicalWarrantyWorksheet.productLabel')} :</Typography>
        <Typography variant="subtitle1">
          {i18n.language === 'fr'
            ? mechanicalProduct.nameFr
            : mechanicalProduct.nameEn}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.duration')} :</Typography>
        <Typography variant="subtitle1">{mechanicalProduct.duration}</Typography>
      </Stack>
    </Stack>
  )
}

export default MechanicalWarrantySection